import { itemNamesRegex, riddleRegex } from "./regex";
import { riddles, Riddle } from "./riddles";

export function getItemDescription(itemName: string, roomTitle: string, contentText: string): string {
    try {
        const match: RegExpMatchArray | null = itemName.match(itemNamesRegex);
        const actualItemName: string = match ? match[1].trim() : "";
        console.log("Inspecting item:", actualItemName);
        console.log("Room title:", roomTitle);
        console.log("Room content:", contentText);

        const riddleMatch: RegExpMatchArray | null = contentText.match(riddleRegex);
        if (riddleMatch) {
            const riddleQuestion: string = riddleMatch[1].trim();
            console.log("Inspecting riddle:", riddleQuestion);
            const currentRiddle: Riddle | undefined = getCurrentRiddle(riddleQuestion);
            console.log("Current riddle:", currentRiddle);
            if (currentRiddle) {
                if (actualItemName.toLowerCase() === "clue") {
                    console.log("Returning clue:", currentRiddle.clue);
                    return currentRiddle.clue ? `${currentRiddle.clue}` : "No clue available for this riddle.";
                } else {
                    return "This can help you with the wizard's riddles.";
                }
            } else {
                console.log("Riddle not found in riddles.ts.");
                return "No riddle found.";
            }
        }

        if (actualItemName.toLowerCase() === "clue") {
            console.log("No riddle found in this room.");
            return "There is no riddle in this room.";
        } else if (actualItemName.toLowerCase() === "tower key") {
            return "An old key that can be used to unlock the tower.";
        } else if (actualItemName.toLowerCase() === "glasses") {
            return "A pair of glasses. They seem to have a faint enchantment on them, allowing you to see hidden clues.";
        }
        else if (actualItemName.toLowerCase() === "scratcher") {
            return "A small metal tool used for scratching off lottery tickets. Maybe it can be used for something else?";
        }
        else {
            console.log("Unknown item:", actualItemName);
            return "Item details not available.";
        }
    } catch (error) {
        console.error("An error occurred while processing item description:", error);
        return "An error occurred while processing item description.";
    }
}

// Adjusted to take riddleQuestion as a parameter and use it to find the riddle
function getCurrentRiddle(riddleQuestion: string): Riddle | undefined {
    // Directly use the passed riddleQuestion to find the corresponding Riddle object
    return riddles.find(riddle => riddle.question.trim().toLowerCase() === riddleQuestion.trim().toLowerCase());
}

export function handleInspect(itemName: string, itemDescription: string): void {
    const match: RegExpMatchArray | null = itemName.match(itemNamesRegex);
    const actualItemName: string = match ? match[1].trim() : itemName;
    const processedItemName: string = actualItemName.charAt(0).toUpperCase() + actualItemName.slice(1);

    console.log(`${processedItemName}: ${itemDescription}`);
    alert(`${processedItemName}: ${itemDescription}`);
}
